import { useRef, useCallback } from 'react';
import {
  Navbar,
  ChatSidebar,
  ChatArea,
  InputBar,
} from '../components';

import { useChatStore } from '../store/chatStore';
import { chatApi } from '../lib/api';
import "../assets/css/Chatbot.css";

const generateId = () =>
  Math.random().toString(36).substring(2, 15);

/** Map API source → store Source shape */
const mapSource = (s) => ({
  title: s.title || s.detail || '',
  category: s.category || s.type || '',
  type: s.type || 'Knowledge Base',
  description: s.description || '',
  sharepointUrl: s.sharepointUrl || '',
  websiteUrl: s.websiteUrl || '',
});

function Chatbot() {
  const inputRef = useRef(null);

  const {
    addMessage,
    setThinking,
    activeRole,
    activeSessionId,
    getChatHistoryForApi,
  } = useChatStore();

  const handleSend = useCallback(
    async (text) => {
      // 1. Add user message immediately
      const userMsg = {
        id: generateId(),
        role: 'user',
        content: text,
        timestamp: new Date(),
      };

      addMessage(userMsg);
      setThinking(true);

      try {
        // 2. Call backend API
        const response = await chatApi.sendMessage({
          query: text,
          session_id:
            activeSessionId || generateId(),
          role: activeRole,
          chat_history: getChatHistoryForApi(4),
        });

        // 3. Session ID is managed by the store — no override needed

        // 4. Add assistant message
        const assistantMsg = {
          id: generateId(),
          role: 'assistant',
          content: response.answer,
          timestamp: new Date(),
          sources: (response.sources || []).map(
            mapSource
          ),
          followUps:
            response.follow_up_suggestions || [],
          queryType: response.query_type || undefined,
          originalQuery: text,
        };

        setThinking(false);
        addMessage(assistantMsg);
      } catch (err) {
        console.error('[Chatbot] API error:', err);

        const errorMsg = {
          id: generateId(),
          role: 'assistant',
          content:
            '❌ Sorry, something went wrong while contacting the server. Please try again.',
          timestamp: new Date(),
        };

        setThinking(false);
        addMessage(errorMsg);
      }
    },
    [
      activeRole,
      activeSessionId,
      addMessage,
      setThinking,
      getChatHistoryForApi,
    ]
  );

  const focusInput = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div
      className="h-screen flex flex-col"
      style={{ background: '#0a1628' }}
    >
      <Navbar />

      <div className="flex flex-1 overflow-hidden">
        <ChatSidebar />

        <div className="flex-1 flex flex-col overflow-hidden">
          <ChatArea
            onSend={handleSend}
            onFocusInput={focusInput}
          />
          <InputBar
            ref={inputRef}
            onSend={handleSend}
          />
        </div>
      </div>
    </div>
  );
}

export default Chatbot;